import { IResponseState } from "../../../components/Modals/ResponseModal/module/constants";

import {
  LIST_IDENTIFIER,
  LOADER_IDENTIFIER,
  STATE_IDENTIFIER,
} from "./constants";

const {
  TEMPORARY_ABILITATIONS,
  SELECTED_TEMPORARY_ABILITATION,
  REQUEST_STATE,
  FIELDS,
  EMERGENCY_TEMPORARY_ABILITATIONS,
  SHOW_EMERGENCY,
  SHOW_EMERGENCY_LOADER,
  MISSING_ENTITLEMENTS,
} = STATE_IDENTIFIER;

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  [SHOW_EMERGENCY]: false,
  [SHOW_EMERGENCY_LOADER]: true,
  [EMERGENCY_TEMPORARY_ABILITATIONS]: {
    [LIST_IDENTIFIER]: [],
    [LOADER_IDENTIFIER]: false,
    [SELECTED_TEMPORARY_ABILITATION]: null,
    [FIELDS]: {
      [LIST_IDENTIFIER]: [],
      [LOADER_IDENTIFIER]: false,
    },
  },
  [TEMPORARY_ABILITATIONS]: {
    [LIST_IDENTIFIER]: [],
    [LOADER_IDENTIFIER]: false,
    [SELECTED_TEMPORARY_ABILITATION]: null,
    [FIELDS]: {
      [LIST_IDENTIFIER]: [],
      [LOADER_IDENTIFIER]: false,
    },
  },
  [MISSING_ENTITLEMENTS]: [],
  [REQUEST_STATE]: IResponseState.PENDING,
};
